import {
  Checkbox,
  DirectionalHint,
  IconButton,
  Stack,
  TooltipHost,
  useTheme,
} from '@fluentui/react';
import React, { useState } from 'react';
import { useStyles } from './index.styles';
import { ApprovalTestGroups_approvalTestGroups_nodes_approvalTestItems_nodes } from '../../TestGroupsModal/__generated__/ApprovalTestGroups';

type TestGroupItemsListProps = {
  items: ApprovalTestGroups_approvalTestGroups_nodes_approvalTestItems_nodes[];
  selectedIds: string[];
  onToggle: (id: string, checked: boolean) => void;
  onView: (
    item:
      | ApprovalTestGroups_approvalTestGroups_nodes_approvalTestItems_nodes
      | undefined
  ) => void;
  formViewId: string | undefined;
};

export const TestGroupItemsList: React.FC<TestGroupItemsListProps> = ({
  items = [],
  selectedIds = [],
  onToggle,
  onView,
  formViewId,
}) => {
  const theme = useTheme();
  const style = useStyles();
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  if (!items.length) {
    return null;
  }
  return (
    <Stack tokens={{ childrenGap: 8 }} className={style.itemStyle}>
      {items.map((item) => (
        <Stack
          horizontal
          key={item.id}
          onMouseEnter={() => setHoveredId(item.id)}
          onMouseLeave={() => setHoveredId(null)}
          verticalAlign="center"
          id={item.id}
          style={{
            height: 40,
            backgroundColor:
              formViewId === item.id
                ? theme.palette.neutralLighterAlt
                : undefined,
          }}
        >
          <TooltipHost
            content={item.comment}
            directionalHint={DirectionalHint.topCenter}
          >
            <Stack style={{ width: 230 }}>
              <Checkbox
                label={
                  item.comment.length > 30
                    ? `${item.comment.slice(0, 27)}...`
                    : item.comment
                }
                checked={selectedIds.includes(item.id)}
                onChange={(e, checked) => onToggle(item.id, !!checked)}
              />
            </Stack>
          </TooltipHost>
          {(hoveredId === item.id || formViewId === item.id) && (
            <Stack className={style.iconStyle}>
              <IconButton
                iconProps={{ iconName: 'CaretRightSolid8' }}
                ariaLabel="View"
                onClick={() =>
                  onView(formViewId === item.id ? undefined : item)
                }
              />
            </Stack>
          )}
        </Stack>
      ))}
    </Stack>
  );
};
